module.exports = "\n<div class=\"row\">\n  <div class=\"col-sm-12\">\n      <div id=\"map\" style=\"height: 550px;\"></div>\n  </div>\n</div>\n\n"